import { render, staticRenderFns } from "./RecordatorioForm.vue?vue&type=template&id=31d15c44&scoped=true&"
import script from "./RecordatorioForm.vue?vue&type=script&lang=js&"
export * from "./RecordatorioForm.vue?vue&type=script&lang=js&"
import style0 from "./RecordatorioForm.vue?vue&type=style&index=0&id=31d15c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d15c44",
  null
  
)

export default component.exports